export default __webpack_public_path__ + "382a8518c1807ac0e5298503faba882b.gif";